import type { DragEvent } from "react";
import React from "react";

interface UseDragOverOptions {
    onDragEnter?: () => void;
    onDragLeave?: () => void;
}

export function useDragOver({ onDragEnter, onDragLeave }: UseDragOverOptions) {
    const dragCounter = React.useRef(0);

    const handleDragEnter = (e: DragEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter.current += 1;
        if (dragCounter.current === 1) {
            onDragEnter?.();
        }
    };

    const handleDragLeave = (e: DragEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter.current -= 1;
        if (dragCounter.current === 0) {
            onDragLeave?.();
        }
    };

    const handleDragOver = (e: DragEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e: DragEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter.current = 0;
        onDragLeave?.();
    };

    return {
        onDragEnter: handleDragEnter,
        onDragLeave: handleDragLeave,
        onDragOver: handleDragOver,
        onDrop: handleDrop,
    };
}
